import { useEffect } from 'react'
import { onAuthStateChanged, auth } from '@/lib/firebase'
import { useAuthStore } from '@/stores/auth'

export function useAuth() {
  const setFirebaseUser = useAuthStore((s) => s.setFirebaseUser)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setFirebaseUser(user)
    })
    return unsubscribe
  }, [setFirebaseUser])

  return useAuthStore()
}
